// Arbor is an internal eval/replay harness. Telemetry (metrics + error reports)
// is suppressed there so harness runs don't pollute production signals.
export function isArborHost() {
  return typeof window !== 'undefined' && window.location.pathname.startsWith('/breeze-engine-arbor');
}